// Generated by web/scripts/avatars.ts; edit the specs there and re-run it.

/** One illustrated avatar: served as `/avatars/<id>.svg` by the web app. */
export type AvatarPresetEntry = { id: string; group: 'people' | 'animals'; label: string };

export const AVATAR_PRESETS: readonly AvatarPresetEntry[] = [
  { id: 'people-01', group: 'people', label: 'Person with an afro' },
  { id: 'people-02', group: 'people', label: 'Person with bangs' },
  { id: 'people-03', group: 'people', label: 'Person with a fringe' },
  { id: 'people-04', group: 'people', label: 'Person with bantu knots' },
  { id: 'people-05', group: 'people', label: 'Person in a bear hat' },
  { id: 'people-06', group: 'people', label: 'Person with a bun' },
  { id: 'people-07', group: 'people', label: 'Person with a top knot' },
  { id: 'people-08', group: 'people', label: 'Person with space buns' },
  { id: 'people-09', group: 'people', label: 'Person with cornrows' },
  { id: 'people-10', group: 'people', label: 'Person with braids and a beard' },
  { id: 'people-11', group: 'people', label: 'Person with dreadlocks' },
  { id: 'people-12', group: 'people', label: 'Person with long dreadlocks' },
  { id: 'people-13', group: 'people', label: 'Person with a flat top' },
  { id: 'people-14', group: 'people', label: 'Person with a high top' },
  { id: 'people-15', group: 'people', label: 'Person with a grey bun' },
  { id: 'people-16', group: 'people', label: 'Person with grey hair and glasses' },
  { id: 'people-17', group: 'people', label: 'Person with short grey hair and a beard' },
  { id: 'people-18', group: 'people', label: 'Person in a beanie' },
  { id: 'people-19', group: 'people', label: 'Person in a cap' },
  { id: 'people-20', group: 'people', label: 'Person in a hijab' },
  { id: 'people-21', group: 'people', label: 'Person with long hair' },
  { id: 'people-22', group: 'people', label: 'Person with a big afro' },
  { id: 'people-23', group: 'people', label: 'Person with long hair and bangs' },
  { id: 'people-24', group: 'people', label: 'Person with long curly hair' },
  { id: 'people-25', group: 'people', label: 'Person with wavy hair and glasses' },
  { id: 'people-26', group: 'people', label: 'Person with shoulder-length hair' },
  { id: 'people-27', group: 'people', label: 'Person with a bob' },
  { id: 'people-28', group: 'people', label: 'Person with a bob and bangs' },
  { id: 'people-29', group: 'people', label: 'Person with messy bangs' },
  { id: 'people-30', group: 'people', label: 'Person with side bangs' },
  { id: 'people-31', group: 'people', label: 'Person with straight hair' },
  { id: 'people-32', group: 'people', label: 'Person with a mohawk' },
  { id: 'people-33', group: 'people', label: 'Person with a spiky mohawk' },
  { id: 'people-34', group: 'people', label: 'Person with a shaved head and a beard' },
  { id: 'people-35', group: 'people', label: 'Person with a bald head and glasses' },
  { id: 'people-36', group: 'people', label: 'Person with a smooth head' },
  { id: 'people-37', group: 'people', label: 'Person with a quiff' },
  { id: 'people-38', group: 'people', label: 'Person with a buzz cut' },
  { id: 'people-39', group: 'people', label: 'Person with a short buzz cut and a moustache' },
  { id: 'people-40', group: 'people', label: 'Person with a fade' },
  { id: 'people-41', group: 'people', label: 'Person with short hair and sunglasses' },
  { id: 'people-42', group: 'people', label: 'Person with short tidy hair' },
  { id: 'people-43', group: 'people', label: 'Person with short curly hair and glasses' },
  { id: 'people-44', group: 'people', label: 'Person with a side parting and a beard' },
  { id: 'people-45', group: 'people', label: 'Person with short spiky hair' },
  { id: 'people-46', group: 'people', label: 'Person in a turban and a beard' },
  { id: 'people-47', group: 'people', label: 'Person with twists' },
  { id: 'people-48', group: 'people', label: 'Person with long twists' },
  { id: 'animal-fox', group: 'animals', label: 'Fox' },
  { id: 'animal-cat', group: 'animals', label: 'Cat' },
  { id: 'animal-dog', group: 'animals', label: 'Dog' },
  { id: 'animal-panda', group: 'animals', label: 'Panda' },
  { id: 'animal-bear', group: 'animals', label: 'Bear' },
  { id: 'animal-koala', group: 'animals', label: 'Koala' },
  { id: 'animal-tiger', group: 'animals', label: 'Tiger' },
  { id: 'animal-lion', group: 'animals', label: 'Lion' },
  { id: 'animal-rabbit', group: 'animals', label: 'Rabbit' },
  { id: 'animal-mouse', group: 'animals', label: 'Mouse' },
  { id: 'animal-hamster', group: 'animals', label: 'Hamster' },
  { id: 'animal-frog', group: 'animals', label: 'Frog' },
  { id: 'animal-monkey', group: 'animals', label: 'Monkey' },
  { id: 'animal-pig', group: 'animals', label: 'Pig' },
  { id: 'animal-cow', group: 'animals', label: 'Cow' },
  { id: 'animal-unicorn', group: 'animals', label: 'Unicorn' },
  { id: 'animal-wolf', group: 'animals', label: 'Wolf' },
  { id: 'animal-raccoon', group: 'animals', label: 'Raccoon' },
  { id: 'animal-owl', group: 'animals', label: 'Owl' },
  { id: 'animal-penguin', group: 'animals', label: 'Penguin' },
  { id: 'animal-chick', group: 'animals', label: 'Chick' },
  { id: 'animal-horse', group: 'animals', label: 'Horse' },
  { id: 'animal-turtle', group: 'animals', label: 'Turtle' },
  { id: 'animal-octopus', group: 'animals', label: 'Octopus' },
  { id: 'animal-whale', group: 'animals', label: 'Whale' },
  { id: 'animal-dolphin', group: 'animals', label: 'Dolphin' },
  { id: 'animal-butterfly', group: 'animals', label: 'Butterfly' },
  { id: 'animal-ladybird', group: 'animals', label: 'Ladybird' },
  { id: 'animal-bee', group: 'animals', label: 'Bee' },
  { id: 'animal-hedgehog', group: 'animals', label: 'Hedgehog' },
  { id: 'animal-sloth', group: 'animals', label: 'Sloth' },
  { id: 'animal-otter', group: 'animals', label: 'Otter' },
  { id: 'animal-giraffe', group: 'animals', label: 'Giraffe' },
  { id: 'animal-elephant', group: 'animals', label: 'Elephant' },
  { id: 'animal-parrot', group: 'animals', label: 'Parrot' },
  { id: 'animal-dragon', group: 'animals', label: 'Dragon' },
];
